import React from "react"
import { Button } from "@mui/material"

const ActionButton = (props) => {
    const { url } = props

    return (
        <Button href={url}>New Recipe</Button>
    );
}

export default ActionButton
